import { render, staticRenderFns } from "./oxfordNew.vue?vue&type=template&id=028fb2a4&scoped=true"
import script from "./oxfordNew.vue?vue&type=script&lang=js"
export * from "./oxfordNew.vue?vue&type=script&lang=js"
import style0 from "./oxfordNew.vue?vue&type=style&index=0&id=028fb2a4&prod&lang=css"
import style1 from "./oxfordNew.vue?vue&type=style&index=1&id=028fb2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028fb2a4",
  null
  
)

export default component.exports